<section class="section mentions-legales has-background-white is-section-bottom is-paddingless">
    <div class="is-divider"></div>
    <div class="container is-fluid">
        <btl-breadcrumb [paramUrl]="paramToAdd"></btl-breadcrumb>
        @if (blockId) {
            <section class="accordions disclaimer">
                <article class="accordion" [ngClass]="{ 'is-active': isLegals }">
                    <div class="accordion-header disclaimer-header is-grouped" (click)="toggleLegals()">
                        <button class="toggle button is-bordered" aria-label="toggle"></button>
                        <p class="title is-size-6 is-6" data_bfkeylabel="boutique.default.legals_mentions">
                            Mentions légales
                        </p>
                    </div>
                    <div class="accordion-body is-clipped">
                        <div class="accordion-content">
                            <div class="disclaimer-content subtitle" togglebox="left">
                                <btl-cms-block
                                    [blockId]="blockId"
                                    [battlefront]="isBattlefront"
                                    [isBta]="isBta"
                                ></btl-cms-block>
                                <div class="rows">
                                    <div class="row"></div>
                                    <div class="row"></div>
                                </div>
                                @if (additionalBlockId) {
                                    <btl-cms-block
                                        [blockId]="additionalBlockId"
                                        [isBta]="isBta"
                                        [battlefront]="isBattlefront"
                                    ></btl-cms-block>
                                }
                            </div>
                        </div>
                    </div>
                </article>
            </section>
        }
    </div>
</section>
